import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import { adminApi } from "../lib/adminApi";
import AdminLogin from "../components/admin/AdminLogin";
import AdminPanel from "../components/admin/AdminPanel";

export default function Admin() {
    const [user, setUser] = useState(undefined); // undefined = verificando

    useEffect(() => {
        const check = async () => {
            if (!localStorage.getItem("lolopets_token")) {
                setUser(null);
                return;
            }
            try {
                const { data } = await adminApi.get("/auth/me");
                setUser(data);
            } catch {
                localStorage.removeItem("lolopets_token");
                setUser(null);
            }
        };
        check();
    }, []);

    const logout = () => {
        localStorage.removeItem("lolopets_token");
        setUser(null);
    };

    return (
        <>
            <Toaster richColors position="top-center" />
            {user === undefined ? (
                <div data-testid="admin-loading" className="flex min-h-screen items-center justify-center bg-white">
                    <div className="h-10 w-10 animate-spin rounded-full border-4 border-brand-magenta border-t-transparent" />
                </div>
            ) : user ? (
                <AdminPanel user={user} onLogout={logout} />
            ) : (
                <AdminLogin onLogin={setUser} />
            )}
        </>
    );
}
